import { render, staticRenderFns } from "./CarteiraPedidosPersonalizadoComercial.vue?vue&type=template&id=010b51a0&scoped=true&"
import script from "./CarteiraPedidosPersonalizadoComercial.vue?vue&type=script&lang=js&"
export * from "./CarteiraPedidosPersonalizadoComercial.vue?vue&type=script&lang=js&"
import style0 from "./CarteiraPedidosPersonalizadoComercial.vue?vue&type=style&index=0&id=010b51a0&scoped=true&lang=css&"
import style1 from "./CarteiraPedidosPersonalizadoComercial.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b51a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VDialog,VIcon,VRow,VSpacer})
